import { CSSProperties, FC, ReactNode } from 'react';

import styled from 'styled-components';

export const CheckboxContainer = styled.div<{
  justifyContent?: CSSProperties['justifyContent'];
}>`
  display: flex;
  flex-wrap: wrap;
  padding: 20px 20px 10px;
  justify-content: ${({ justifyContent = 'space-between' }) => justifyContent};
`;

const LeftSection = styled.div`
  @media (max-width: 395px) {
    padding-bottom: 20px;
  }
`;

const RightSection = styled.div``;

const BookerCheckboxContainer: FC<{
  leftSection?: ReactNode;
  rightSection?: ReactNode;
  justifyContent?: CSSProperties['justifyContent'];
}> = ({ leftSection, rightSection, justifyContent }) => {
  return (
    <CheckboxContainer justifyContent={justifyContent}>
      <LeftSection>{leftSection}</LeftSection>
      <RightSection>{rightSection}</RightSection>
    </CheckboxContainer>
  );
};

export default BookerCheckboxContainer;
